import type { LocationInputMethod } from "stores/location-input/locationInputSlice"

// Tracking is optional: storage failures (private mode, blocked storage) must never break search.
const getLocalStorageItem = (key: string) => {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

const setLocalStorageItem = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value)
  } catch {
    // ignore
  }
}

const removeLocalStorageItem = (key: string) => {
  try {
    localStorage.removeItem(key)
  } catch {
    // ignore
  }
}

type SearchSurface =
  | "homepage hero"
  | "results header"
  | "destination page"
  | "property detail header"
  | "mobile sheet"

const LOCATION_INPUT_METHOD_KEY = "searchLocationInputMethod"
const SEARCH_SURFACE_KEY = "searchSurface"

export const getDesktopSearchSurface = (
  pathname: string | null,
): SearchSurface => {
  if (pathname === "/" || pathname === "/home") return "homepage hero"
  if (pathname?.startsWith("/vacation-rentals")) return "results header"
  if (
    pathname?.startsWith("/detail") ||
    pathname?.startsWith("/multi-unit-detail")
  ) {
    return "property detail header"
  }
  return "destination page"
}

/** Read by the "view search results page" event that follows this search. */
export const stampLocationSearchTracking = (
  method: LocationInputMethod,
  surface: SearchSurface,
) => {
  setLocalStorageItem(LOCATION_INPUT_METHOD_KEY, method)
  setLocalStorageItem(SEARCH_SURFACE_KEY, surface)
}

export const consumeLocationSearchTracking = () => {
  const locationInputMethod = getLocalStorageItem(LOCATION_INPUT_METHOD_KEY)
  const searchSurface = getLocalStorageItem(SEARCH_SURFACE_KEY)
  removeLocalStorageItem(LOCATION_INPUT_METHOD_KEY)
  removeLocalStorageItem(SEARCH_SURFACE_KEY)
  return { locationInputMethod, searchSurface }
}
